/**
 * IMPORTS
 */

import { ReactQueryProvider } from "@/hooks/react-query/react-query-provider";

import { AppRoutes } from "@/app/routes/routes-index";
import { Providers } from "@/context/react-query/provider-query";

function App() {
  return (
    <Providers>
      <ReactQueryProvider>
        <AppRoutes />
      </ReactQueryProvider>
    </Providers>
  );
}

/**
 * EXPORTS
 */
export default App;
